import { Component, Inject, OnInit } from '@angular/core';
import { Task } from '@features/tasks/models/task';
import { Observable } from 'rxjs';
import { TaskConfig, TASK_CONFIG } from '@features/tasks/services/task-config';
import { TaskService } from '@features/tasks/services/task.service';
import { TaskDetailsComponent } from '../details/task-details.component';
import { FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-task-edit',
  templateUrl: '../details/task-details.component.html',
  styleUrls: ['../details/task-details.component.scss']
})
export class TaskEditComponent extends TaskDetailsComponent implements OnInit {
  constructor(
    @Inject(TASK_CONFIG) private readonly config: TaskConfig,
    taskService: TaskService,
    protected fb: FormBuilder
  ) {
    super(taskService, fb);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  get saveLabel(): string {
    return this.config.edit.saveLabel;
  }

  get title(): string {
    return this.config.edit.title;
  }

  readonly isEditMode = true;

  content(): Observable<Task.Model> {
    return this.taskService.getTaskForEdit(this.entityId, this.taskId);
  }
}
